'use client';

import { useProductsRecoTracking, type TrackingProps } from './useProductsRecoTracking';

export const ProductsRecoTracking = (props: TrackingProps) => {
  useProductsRecoTracking(props);

  return null;
};
